import { useEffect } from 'react';

export function useDocumentTitle(title) {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = title ? `${title} | Oshikem` : 'Oshikem';

    // Optional: Resets title back when the component unmounts
    return () => {
      document.title = originalTitle;
    };
  }, [title]); // Runs again if the title string changes
}

